import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRightIcon } from "@heroicons/react/outline";
import classNames from "classnames";
import clsx from "clsx";
import React from "react";
import { Bullet } from "./Bullet";
import { Link } from "./Link";
import { PageContainer } from "./PageContainer";
export function Feature(_param) {
    var heading = _param.heading, subheading = _param.subheading, _bullet = _param.bullet, bullet = _bullet === void 0 ? "" : _bullet, _image = _param.image, image = _image === void 0 ? null : _image, _flip = _param.flip, flip = _flip === void 0 ? false : _flip, _cta = _param.cta, cta = _cta === void 0 ? "" : _cta, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, _direction = _param.direction, direction = _direction === void 0 ? "row" : _direction, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "bullet",
        "image",
        "flip",
        "cta",
        "animate",
        "direction"
    ]);
    var dir = function() {
        if (direction === "row") {
            if (flip) {
                return "md:flex-row-reverse";
            }
            return "md:flex-row";
        }
        if (direction === "column") {
            if (flip) {
                return "md:flex-column-reverse";
            }
            return "md:flex-column";
        }
    }();
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({
        dontContain: true
    }, rest), {
        children: /*#__PURE__*/ _jsxs("div", {
            className: clsx("relative justify-between items-center max-w-full w-full", "flex flex-col ", dir),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-6 flex flex-col px-3 min-w-[300px] max-w-full flex-1",
                    children: [
                        bullet && /*#__PURE__*/ _jsx(Bullet, {
                            children: bullet
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: clsx("text-4xl even:!mt-2 font-bold leading-relaxed "),
                            children: heading
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: " font-medium opacity-80 max-w-xl",
                            children: subheading
                        }),
                        cta && /*#__PURE__*/ _jsx("div", {
                            children: cta
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "w-12 h-12"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx("flex flex-col flex-shrink-0 px-3 items-center flex-1", "max-w-[500px] min-w-[300px]"),
                    children: image
                })
            ]
        })
    }));
}
export function FeatureLink(_param) {
    var children = _param.children, _hideArrow = _param.hideArrow, hideArrow = _hideArrow === void 0 ? false : _hideArrow, _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, rest = _object_without_properties(_param, [
        "children",
        "hideArrow",
        "className",
        "href"
    ]);
    return /*#__PURE__*/ _jsxs(Link, _object_spread_props(_object_spread({
        href: href,
        className: classNames("flex items-center font-semibold space-x-2", className)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: children
            }),
            !hideArrow && /*#__PURE__*/ _jsx(ArrowRightIcon, {
                className: "mx-[10px] inline w-4 h-4 "
            })
        ]
    }));
}
Feature.Link = FeatureLink;
